import { Component } from 'react'
import {JSONFetcher, ProjectList, findApiV4Link, ProjectTeaserWithTracking} from 'shared'

export class Recommender extends Component {
  constructor(props) {
    super(props)
    this.state = { isLoading: true, projects: [] }
  }

  componentDidMount() {
    JSONFetcher.load({
      url:     this.props.apiUrl,
      success: (response) => {
        this.loadProjects( findApiV4Link({ofObject: response, withRel: 'recommended_projects_url'}) )
      }
    })
  }

  shuffle = (array) => {
    for (let i = array.length; i; i--) {
      let j = Math.floor(Math.random() * i);
      [array[i - 1], array[j]] = [array[j], array[i - 1]];
    }
    return array;
  };

  loadProjects = (url) => {
    JSONFetcher.load({
      url:     url,
      success: (response) => {
        this.setState({ projects: this.shuffle(response.data || []), isLoading: false })
      }
    })
  };

  renderTeaser = (project, index) => {
    return <ProjectTeaserWithTracking
      project={project}
      index={index}
      trackingPath='/project-page/recommender'
      sourceProjectID={this.props.sourceProject}
      openInTab
      teaserTracking='ppp-project-recommendation'
    />
  }

  render() {
    return <div>
      <h2 className="text-3xl text-center m-b">{I18n.t('projects.show.recommender.headline')}</h2>

      <ProjectList
        render={this.renderTeaser}
        projects={this.state.projects}
        isLoading={this.state.isLoading}
        perPage={3}
      />
    </div>
  }
}
